/**
 * S10-VACall (escape) — book a call. Reachable from any question.
 * Lists the open questions and offers a language choice.
 */
import { useNavigate } from 'react-router-dom';

export function TalkItThrough(): JSX.Element {
  const navigate = useNavigate();
  return (
    <div className="flow flow--single">
      <div className="stage-card">
        <h1>Let&rsquo;s talk it through.</h1>
        <p className="stage-card__lede">
          Some decisions are easier on a quick call. Pick a time that works and we&rsquo;ll go
          through the open questions together &mdash; no pressure, no charge.
        </p>

        <div className="pb-surface">
          <div className="pb-option__label" style={{ marginBottom: 'var(--pb-2)' }}>
            Still open
          </div>
          <p className="pb-note--flag pb-note" role="note">
            The shower valve and the countertop are the two holding up a firm start date.
          </p>
        </div>

        <div className="subfield">
          <span className="pb-label">Which language do you prefer?</span>
          <div className="subfield__choices subfield__choices--row">
            <button type="button" className="pb-btn pb-btn--ghost">English</button>
            <button type="button" className="pb-btn pb-btn--ghost">Espa&ntilde;ol</button>
          </div>
        </div>

        <div className="q-actions">
          <button type="button" className="pb-btn pb-btn--next pb-btn--lg" onClick={() => navigate('/service')}>
            Find a time
          </button>
        </div>
      </div>
    </div>
  );
}
